module.exports = __webpack_public_path__ + "img/mq.c689cbca.svg";